import React from "react";
import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

const thClass =
  "h-12 py-3 text-center text-sm font-semibold uppercase tracking-wide text-slate-600";

/**
 * shadcn header for the redesigned "Rezepte" bill table (V2). Same columns as the
 * original `PatientBillTableHeader`, styled like the SEPA / AllTransactions cards.
 */
const RxPriceTableHeader: React.FC = () => (
  <TableHeader>
    <TableRow className="border-b border-solid border-slate-200 bg-slate-100 hover:bg-slate-100">
      <TableHead className={`${thClass} text-left`}>RX Nummer</TableHead>
      <TableHead className={`${thClass} text-left`}>Rx Datum</TableHead>
      <TableHead className={`${thClass} text-left`}>Heilmittel und Menge</TableHead>
      <TableHead className={`${thClass} text-right`}>Gesamtpreis (€)</TableHead>
      <TableHead className={`${thClass} text-right`}>Gezahlter/Fakturierter Betrag (€)</TableHead>
      <TableHead className={`${thClass} text-right`}>Fällig (€)</TableHead>
      <TableHead className={thClass}>Abrechnungsnummer</TableHead>
      <TableHead className={thClass}>Aktionen</TableHead>
    </TableRow>
  </TableHeader>
);

export default RxPriceTableHeader;
